// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"488":"axiom","532":"styles","592":"common","736":"vendor"}[chunkId] || chunkId) + "." + {"241":"62f857499ab9687f0b2d","488":"36e8cbd2c7a3fc2fce9b","532":"8bbf4a81c065a9b9699d","592":"945661aa78a08854d644","736":"ba625c7a7bf4ad54a81b"}[chunkId] + ".js";
};